/**
 * @file automatically generated from MApp.Endpoints.Models.Scope
 */

export enum Scope {
	Public = 'public'
}
